import React, { useEffect, useState } from 'react'
import { useBranding } from '../context/BrandingContext';
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL, getCookie, getHeaders } from '../helper/commonApi';
import Loader from '../components/loader';

const PricingCheckoutComponent = () => {
    const { colors, portalID } = useBranding();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const [plan, setPlan] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showStaffSuccess, setShowStaffSuccess] = useState(false);


    const [agreed, setAgreed] = useState(false);
    const [error, setError] = useState(""); // for showing inline error

    const userId = localStorage.getItem('_register_GRE_LOGIN_userId');

    useEffect(() => {
        const jwtToken = getCookie('_GRE_JWT_TOKEN');

        if (!userId || !jwtToken) {
            localStorage.clear();
            document.cookie = "_GRE_JWT_TOKEN=; max-age=0; path=/;";
            navigate('/')
            return;
        }

        getPlanDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const getPlanDetails = async () => {
        setLoading(true);
        try {
            const res = await axios.post(`${API_URL}/get-plan-details`, {
                package_id: id
            }, {
                headers: getHeaders()
            });

            if (res.status === 200) {
                setPlan(res?.data?.data);
                setLoading(false);
            } else {
                console.error("Failed to fetch dashboard");
                setLoading(false);
            }
        } catch (err) {
            console.error("Error fetching dashboard:", err);
            setLoading(false);
        }
    }

    const makePayment = async () => {
        if (!agreed) {
            setError("You must agree to the Terms and Conditions before proceeding.");
            return;
        }
        setError("");

        try {
            // const stripePromise = loadStripe("pk_test_51RntLbQjWAsrgskIctqi3x5igRQw4X5T1R3z3q9TleNzcBvyHwBkXIJOOupBNIWp1zZEfJcC46rMFxNBslboLuC900nWetYy6y");
            const stripePromise = loadStripe("pk_live_51RntLUHnetQGZSnJhJc86LmofePY7jj0qpq0QOIYHkvf29kOm5bFnfJCZE7meG43xA74R3nw6d0KvIN3W62TUQqS00E75zUq0K");
            const stripe = await stripePromise;

            const payload = {
                package_id: id,
                portal_id: portalID,
                user_id: userId
            };

            const response = await axios.post(`${API_URL}/create-session`, payload, {
                headers: getHeaders()
            });

            const isStaff = response?.data?.data?.is_staff
            const session_id = response?.data?.data?.session_id

            if (isStaff) {
                setShowStaffSuccess(true);
                return;
            }

            const result = await stripe.redirectToCheckout({
                sessionId: session_id
            });

            if (result.error) {
                console.error(result.error.message);
            }

        } catch (err) {
            console.error("Error fetching dashboard:", err);
        }
    }

    return (
        <div>
            {loading ? <Loader />
                :
                <div class="checkout-container">
                    <div class="plan-card">
                        <div class="plan-header">
                            <div>
                                <div><strong>{plan?.name}</strong></div>
                                <div class="plan-price">$ {plan?.price}</div>
                                <div class="plan-validity">Valid: 3 Years from Last Login.</div>
                            </div>
                            <div className="rocket-icon"><svg width="50" height="50" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.1875 5.91667C21.4029 5.91667 20.6504 6.22835 20.0956 6.78314C19.5408 7.33794 19.2292 8.0904 19.2292 8.875C19.2292 9.6596 19.5408 10.4121 20.0956 10.9669C20.6504 11.5217 21.4029 11.8333 22.1875 11.8333V17.75C19.8337 17.75 17.5763 16.815 15.9119 15.1506C14.2475 13.4862 13.3125 11.2288 13.3125 8.875C13.3125 6.5212 14.2475 4.26381 15.9119 2.59943C17.5763 0.935042 19.8337 3.50743e-08 22.1875 0V5.91667ZM5.91667 20.7083H53.25C56.3884 20.7083 59.3983 21.9551 61.6174 24.1742C63.8366 26.3934 65.0833 29.4033 65.0833 32.5417C65.0833 35.6801 63.8366 38.6899 61.6174 40.9091C59.3983 43.1283 56.3884 44.375 53.25 44.375H50.2917V53.25H5.91667V20.7083ZM50.2917 38.4583V26.625H53.25C54.8192 26.625 56.3241 27.2484 57.4337 28.358C58.5433 29.4675 59.1667 30.9725 59.1667 32.5417C59.1667 34.1109 58.5433 35.6158 57.4337 36.7254C56.3241 37.835 54.8192 38.4583 53.25 38.4583H50.2917ZM0 59.1667V65.0833H62.125V59.1667H0ZM36.9792 8.875C36.9792 8.0904 37.2909 7.33794 37.8456 6.78314C38.4004 6.22835 39.1529 5.91667 39.9375 5.91667V0C38.772 -1.7367e-08 37.618 0.229559 36.5412 0.675569C35.4644 1.12158 34.486 1.77531 33.6619 2.59943C32.8378 3.42355 32.1841 4.40192 31.7381 5.47868C31.2921 6.55545 31.0625 7.70952 31.0625 8.875C31.0625 10.0405 31.2921 11.1946 31.7381 12.2713C32.1841 13.3481 32.8378 14.3265 33.6619 15.1506C34.486 15.9747 35.4644 16.6284 36.5412 17.0744C37.618 17.5204 38.772 17.75 39.9375 17.75V11.8333C39.1529 11.8333 38.4004 11.5217 37.8456 10.9669C37.2909 10.4121 36.9792 9.6596 36.9792 8.875Z" fill="white" />
                            </svg></div>
                        </div>

                        <div className='features-list'>
                            <div className='checkout-features'>
                                <div><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_293_189)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.09945 5.34575C-0.366484 6.81169 -0.366484 9.18819 1.09945 10.654L5.34589 14.9005C6.81183 16.3663 9.18833 16.3663 10.6541 14.9005L14.9006 10.654C16.3665 9.18806 16.3665 6.8115 14.9006 5.34575L10.6541 1.09931C9.1882 -0.366437 6.81164 -0.366437 5.34589 1.09931L1.09945 5.34575ZM9.85783 9.85781C10.884 8.83162 10.884 7.16806 9.85783 6.14206C8.83177 5.11588 7.1682 5.11588 6.1422 6.14206C5.11602 7.16819 5.11602 8.83162 6.1422 9.85781C7.16833 10.8838 8.83177 10.8838 9.85795 9.85781H9.85783Z" fill="#2962FF" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_293_189">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></div>
                                <div>1 Free Full Test</div>
                            </div>
                            <div className='checkout-features'>
                                <div><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_293_189)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.09945 5.34575C-0.366484 6.81169 -0.366484 9.18819 1.09945 10.654L5.34589 14.9005C6.81183 16.3663 9.18833 16.3663 10.6541 14.9005L14.9006 10.654C16.3665 9.18806 16.3665 6.8115 14.9006 5.34575L10.6541 1.09931C9.1882 -0.366437 6.81164 -0.366437 5.34589 1.09931L1.09945 5.34575ZM9.85783 9.85781C10.884 8.83162 10.884 7.16806 9.85783 6.14206C8.83177 5.11588 7.1682 5.11588 6.1422 6.14206C5.11602 7.16819 5.11602 8.83162 6.1422 9.85781C7.16833 10.8838 8.83177 10.8838 9.85795 9.85781H9.85783Z" fill="#2962FF" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_293_189">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></div>
                                <div>{plan?.test_limit} Full Practice Tests</div>
                            </div>
                            <div className='checkout-features'>
                                <div><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_293_189)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.09945 5.34575C-0.366484 6.81169 -0.366484 9.18819 1.09945 10.654L5.34589 14.9005C6.81183 16.3663 9.18833 16.3663 10.6541 14.9005L14.9006 10.654C16.3665 9.18806 16.3665 6.8115 14.9006 5.34575L10.6541 1.09931C9.1882 -0.366437 6.81164 -0.366437 5.34589 1.09931L1.09945 5.34575ZM9.85783 9.85781C10.884 8.83162 10.884 7.16806 9.85783 6.14206C8.83177 5.11588 7.1682 5.11588 6.1422 6.14206C5.11602 7.16819 5.11602 8.83162 6.1422 9.85781C7.16833 10.8838 8.83177 10.8838 9.85795 9.85781H9.85783Z" fill="#2962FF" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_293_189">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></div>
                                <div>Dedicated Results</div>
                            </div>
                            <div className='checkout-features'>
                                <div><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_293_189)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.09945 5.34575C-0.366484 6.81169 -0.366484 9.18819 1.09945 10.654L5.34589 14.9005C6.81183 16.3663 9.18833 16.3663 10.6541 14.9005L14.9006 10.654C16.3665 9.18806 16.3665 6.8115 14.9006 5.34575L10.6541 1.09931C9.1882 -0.366437 6.81164 -0.366437 5.34589 1.09931L1.09945 5.34575ZM9.85783 9.85781C10.884 8.83162 10.884 7.16806 9.85783 6.14206C8.83177 5.11588 7.1682 5.11588 6.1422 6.14206C5.11602 7.16819 5.11602 8.83162 6.1422 9.85781C7.16833 10.8838 8.83177 10.8838 9.85795 9.85781H9.85783Z" fill="#2962FF" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_293_189">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></div>
                                <div>In-Depth Analysis</div>
                            </div>
                            <div className='checkout-features'>
                                <div><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_293_189)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.09945 5.34575C-0.366484 6.81169 -0.366484 9.18819 1.09945 10.654L5.34589 14.9005C6.81183 16.3663 9.18833 16.3663 10.6541 14.9005L14.9006 10.654C16.3665 9.18806 16.3665 6.8115 14.9006 5.34575L10.6541 1.09931C9.1882 -0.366437 6.81164 -0.366437 5.34589 1.09931L1.09945 5.34575ZM9.85783 9.85781C10.884 8.83162 10.884 7.16806 9.85783 6.14206C8.83177 5.11588 7.1682 5.11588 6.1422 6.14206C5.11602 7.16819 5.11602 8.83162 6.1422 9.85781C7.16833 10.8838 8.83177 10.8838 9.85795 9.85781H9.85783Z" fill="#2962FF" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_293_189">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></div>
                                <div>Progress Tracking</div>
                            </div>
                        </div>

                        {/* <div className='btn-wrapper'>
                            <button className="btn" style={{ background: colors?.buttonBg, color: colors?.buttonText, width: "100px" }}>Selected</button>
                        </div> */}
                    </div>

                    <div class="sub-summary">
                        <h2>Subscription</h2>
                        <table class="summary-table">
                            <tr>
                                <td>{plan?.name}</td>
                                <td>x1</td>
                                <td>$ {plan?.price}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Discount</td>
                                <td colspan="2" style={{ textAlign: "right" }}>$0.00</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Coupon</td>
                                <td colspan="2" style={{ textAlign: "right" }}>$0.00</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Taxes</td>
                                <td colspan="2" style={{ textAlign: "right" }}>$0.00</td>
                            </tr>
                            <tr class="total">
                                <td></td>
                                <td>Total</td>
                                <td>$ {plan?.price}</td>
                            </tr>
                        </table>

                        <div class="terms">
                            <input
                                type="checkbox"
                                id="agree"
                                name="agree"
                                checked={agreed}
                                onChange={(e) => {
                                    setAgreed(e.target.checked);
                                    if (e.target.checked) setError(""); // clear error on check
                                }}
                                style={{ cursor: "pointer" }}
                            />
                            <label for="agree" style={{ cursor: "pointer" }}>I agree to the subscription <a href="#">Terms and Conditions</a>.</label>
                        </div>
                        {/* Inline Error Message */}
                        {error && (
                            <p className="error-text" style={{ marginLeft: "0" }}>{error}</p>
                        )}

                        <div class="actions">
                            <button onClick={() => navigate("/pricing")} className="btn" style={{ background: "transparent", border: `1px solid ${colors?.primaryColor}` }}>Cancel</button>
                            <button onClick={makePayment} className="btn" style={{ background: colors?.buttonBg, color: colors?.buttonText, width: "100px" }}>Checkout</button>
                        </div>
                    </div>
                </div>
            }

            {showStaffSuccess && (
                <div className="staff-modal-overlay">
                    <div className="modal">
                        <div class="icon-success">
                            <svg
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <h3 style={{ color: colors?.primaryColor, fontSize: "22px", marginBottom: "10px" }}>
                            Package Granted Successfully
                        </h3>
                        {/* <p>Your assigned package has been successfully granted to your account.</p> */}
                        <p>The selected package has been successfully assigned to your account and is now active.</p>

                        <button
                            onClick={() => navigate("/dashboard")}
                            className="btn" style={{ background: colors?.buttonBg, color: colors?.buttonText, width: "100%" }}
                        >
                            Go to Dashboard
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default PricingCheckoutComponent